<template>
    <div>
        <v-row dense>
            <v-col cols=12>
                <span v-for="(link, idx) in links" :key="idx">
                    <span v-html="link.url"></span>
                    <span v-if="!disabled">&nbsp;<v-icon small v-on:click="deleteLink(link.id)">mdi-trash-can-outline</v-icon>&nbsp;&nbsp;</span>
                </span>
                <span v-if="this.show_create_link_button">
                    <span v-if="links != null && links.length > 0">&nbsp;</span>
                    <v-btn :disabled="disabled" icon small v-on:click="showCreateLink()">
                        <v-icon>mdi-link-variant-plus</v-icon>
                    </v-btn>                    
                </span>
                <span v-if="links === null || links.length === 0">
                    <span class="label_none">&nbsp;&nbsp;{{ labelNone }}</span>
                </span>
            </v-col>
        </v-row>
        <div v-if="this.show_create_link_container">
            <v-row dense>
                <v-col cols="12">
                    <v-container style="background-color: bisque;">
                        <v-row dense >
                            <span class="subtitle mx-6 mb-5">
                                <v-icon small class="mr-2">mdi-link-variant-plus</v-icon>
                                Create a new link
                            </span>
                            <v-spacer></v-spacer>
                            <v-btn icon x-small v-on:click="closeCreateLink()" class="mr-2">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-row>
                        <v-row no-gutters class="mx-6">
                            <v-col cols=11>
                                <v-text-field dense v-model="url" label="URL" single-line></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row no-gutters class="mx-6 mb-2">
                            <v-col cols="11">
                                <v-text-field dense v-model="url_text" label="URL tekst" single-line></v-text-field>
                            </v-col>
                            <v-col cols="1">
                                <span v-if="save_ok">
                                    <v-btn icon small v-on:click="createLink(url, url_text)" class="margin-btn">
                                        <v-icon>mdi-content-save-outline</v-icon>
                                    </v-btn>
                                </span>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            links: {
                type: Array,
                required: true,
            },
            labelNone: {
                type: String,
                required: false,
                default: "",
            },
            disabled: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        watch: {
            links: {
                deep: true,
                handler() {
                    this.$emit('updateData', {field: 'links', value: this.links});
                } 
            },
        },
        data() {
            return {
                show_create_link_container: false,
                show_create_link_button: true,
                url: '',
                url_text: '',
            }
        },
        computed: {
            save_ok: function () {
                return (this.url != '' && this.url_text != '');
            },
        },
        methods: {
            createLink(url, text) {
                let idx = 0
                if (this.links != null && this.links.length > 0) {
                    idx = this.links.length + 1;
                }
                let link = new Object();
                if (!url.toLowerCase().startsWith("http")) {
                    url = 'https://' + url;
                }
                let anchortag = '<a href="' + url + '" target="_blank">' + text + '</a>';
                link.id = idx;
                link.url = anchortag;
                this.links.push(link);
                this.closeCreateLink();
            },
            showCreateLink() {
                this.show_create_link_container = true;
                this.show_create_link_button = false;
            },
            closeCreateLink() {
                this.url = '';
                this.url_text = '';
                this.show_create_link_container = false;
                this.show_create_link_button = true;
            },
            deleteLink(param) {
                let idx = this.findWithAttr(this.links, "id", param);
                this.links.splice(idx, 1);
            },
            findWithAttr(array, attr, value) {
                for(let i = 0; i < array.length; i += 1) {
                    if(array[i][attr] === value) {
                        return i;
                    }
                }
                return -1;
            },
        }
    }
</script>

<style scoped>
    .margin-btn {
        margin-top: 10px;
        margin-left: 10px;
    }
    .subtitle {
        color: gray;
        font-size: 14px;
        font-weight: 300;
    }   
    .label_none {
        font-weight: 300;
    }
</style>